import React, { useEffect, Fragment, useState } from "react";
import Services from "../../services/services";
import { Link } from "react-router-dom";
import { moment_datetime, loadImage, QuestionLimit } from "../../../helpers";
const InterestedContent = ({ limitQuestion }) => {
    const service = new Services();

    const [myFeedData, setmyFeedData] = useState();

    useEffect(() => {
        async function feed_data() {
            await service
                .API(`/api/info/interestednews`, {
                    method: "GET"
                })
                .then(data => {
                    if (data.rc_code == "1") {
                        setmyFeedData(data);
                    }
                });
        }
        feed_data();
        return () => {
            setmyFeedData("");
        };
    }, []);

    return (
        <Fragment>
            <div className="p-1">
                {myFeedData && myFeedData.rc_code == "1" ? (
                    <Fragment>
                        {myFeedData &&
                            myFeedData.data.map((val, i) => {
                                return (
                                    <div
                                        className="flex border-b-2 border-gray-50 w-full mx-auto"
                                        key={i}
                                    >
                                        {/* <div
                                            className="flex-none my-auto w-14 h-10 ratio-4-3 rounded-md   bg-center bg-no-repeat bg-contain "
                                            style={{
                                                backgroundImage: `url(${val.nphoto})`
                                            }}
                                        >
                                            <a
                                                rel="noopener noreferrer"
                                                target="_blank"
                                                aria-label={
                                                    val.Question &&
                                                    QuestionLimit(
                                                        val.Question,
                                                        limitQuestion ? limitQuestion : 50
                                                    )
                                                }
                                                href={`/show/${val.No &&
                                                    val.No}`}
                                            ></a>
                                        </div> */}
                                        <div className="flex-1 px-2 py-1">
                                            <a
                                                className="hover:no-underline "
                                                target="_blank"
                                                href={`mediafiles/${val.ndata}`}
                                                title={`เปิดดูไฟล์`}
                                            >
                                                <h3 className="py-1 mb-0 font-light text-sm text-gray-800">
                                                    {/* {QuestionLimit(
                                                        val.Question,
                                                        limitQuestion ? limitQuestion : 50
                                                    )} */}
                                                    {val.Question}
                                                </h3>
                                                <p className="font-light text-sm text-gray-800">{moment_datetime(val.Date)}</p>
                                            </a>
                                        </div>
                                    </div>
                                );
                            })}
                    </Fragment>
                ) : (
                    <Fragment></Fragment>
                )}
            </div>
        </Fragment>
    );
};

export default InterestedContent;
